import React, { FC, useMemo, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { useHistoryNew, toast, getExpireDay, getMemberCardStatus, getPlatform, modalLayer, localStore } from '@utils'
import { format, toPrice } from '@dt/fe-utils'
import CardLevelModal from '../CardLevelModal'
import CardEquityModal from '../CardEquityModal'
import MycardDetailEnter from '../MycardDetailEnter'
import { memberMobx } from '@mobxStore'
import { checkMCBenifit, getGiveAmount, getLevelUpGrowth } from 'common/utils/member'
import { wxConfigG } from '../../../controllers/third'
import './index.scss'

import cardBg from '@img/member/card-bg.png'
interface IProps {
  cardInfo: any;
  onClick?: (event: any) => void;
  isOperate?: boolean;
  isShow?: boolean;
  detailType?: 'open' | 'hide';
  source?: 'home' | 'my' | 'card' | 'activity';
}
const { isWeixin, isWeixinMiniProgram } = getPlatform()
const CardItem: FC<IProps> = (props: IProps) => {
  const history = useHistoryNew()
  const { cardInfo, onClick, isOperate = true, detailType = 'hide', source = 'home' } = props
  const [isLike, setIsLike] = useState<boolean>(!!cardInfo.isDefault)
  const styleType = useMemo(() => {
    if (source === 'home' || source === 'activity') {
      return 'open'
    } else if (source === 'my') {
      return detailType === 'open' ? 'open' : 'half'
    } else if (source === 'card') {
      return detailType === 'open' ? 'open' : 'hide'
    }
  }, [source, detailType])
  const statusInfo = getMemberCardStatus(cardInfo)
  const goRecharge = (url: string) => {
    if (cardInfo.status !== 'enable') {
      toast({ message: i18n.t('mkt.giftCard.frozen') })
      return
    }
    history.push(url)
  }
  const openCardDetail = (event: any) => {
    if (onClick) {
      onClick && onClick(event)
      return
    }
  }
  const showCardEquity = (type: 'equity' | 'store' | 'integral' | 'recharge') => {
    modalLayer(CardEquityModal, { cardInfo, type }).then(() => { }, () => { })
  }
  const getCardLevel = () => {
    modalLayer(CardLevelModal, { cardInfo }).then(() => { }, () => { })
  }
  const goRecord = (type: string) => {
    history.push(`/iRecord/flow/${type}/${cardInfo.cardNo}`)
  }
  const setDefault = (type: boolean) => {
    memberMobx.setDefaultCard({ memberId: cardInfo.memberId, memberCardId: cardInfo.memberCardId, isDefault: type }).then(() => {
      setIsLike(type)
    })
  }
  const handleChangeDefault = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
    setDefault(!isLike)
    if (!isLike) {
      localStore.set('diy_card_choosed', cardInfo.cardId)
      if (isWeixin && isWeixinMiniProgram) {
        wxConfigG.postMessage({
          type: 'defaultCardId',
          defaultCardId: cardInfo.cardId
        })
      }
    }
  }
  useEffect(() => {
    setIsLike(!!cardInfo.isDefault)
  }, [cardInfo])
  const { benifitRecharge, benifitIntegral, benifitMallRate, benifitMealPrice, benifitMealRate, benifitMallPrice, benifitCoupon, benifitNum } = checkMCBenifit(cardInfo.card, cardInfo.balance)
  const isTwoRowLayout = benifitNum >= 5
  const giveAmount = (!location.pathname.includes('home') && cardInfo) ? getGiveAmount(cardInfo) : ''
  return (
    <>
      <div
        className='card-item' style={{
          color: cardInfo.card?.extra?.fontColor || '#B8B8B8',
          borderRightColor: cardInfo.card?.extra?.fontColor || '#B8B8B8'
        }}
        data-cypid='mmgExpandMCard'
        onClick={openCardDetail}
      >
        <div
          className='mci-content'
          style={{ backgroundImage: `Url(${cardInfo.card?.cover || cardBg})` }}
        >
          <div className='mci-content-l'>
            <div className='mci-header'>
              <div className={`mci-header-l${styleType === 'open' ? '' : ' mci-header-l-small'}`}><span>{cardInfo.card?.cardName}</span></div>
              <div className='mci-header-r'>
                {styleType === 'open' && isOperate && source !== 'activity' &&
                  <div data-cypid='mmgChooseDefaultMCard' onClick={handleChangeDefault}>
                    {isLike
                      ? <i className='iconfont icon-like'></i>
                      : <><i className='iconfont icon-like1'></i><span className='set-like'>{i18n.t('mkt.member.memberDefault')}</span></>}
                  </div>}
                {['hide', 'half'].includes(styleType) &&
                  <div className='header-r-hide'>
                    {
                      benifitRecharge &&
                        <>
                          <div className='header-r-hide-price'>{toPrice(cardInfo.balance || 0)}</div>
                          {(benifitMealPrice || benifitMealRate || benifitMallPrice || benifitMallRate) && (
                            <div className='header-r-hide-line'>|</div>
                          )}
                        </>
                    }
                    <div className='header-r-hide-equity'>
                      <div className={cardInfo.card?.discountType && cardInfo.card?.mallDiscountType ? 'header-r-hide-equity-tit' : ''}>
                        {benifitMealPrice &&
                          <span>{i18n.t('order.meals')} {i18n.t('checkout.memberPrice')}</span>}
                        {
                          benifitMealRate &&
                            <span>{cardInfo.card?.products?.length ? i18n.t('mkt.member.someMeals') : i18n.t('order.meals')} {format.toDiscount('discountRate', cardInfo.card?.discountValue)}</span>
                        }
                      </div>
                      <div className={cardInfo.card?.discountType && cardInfo.card?.mallDiscountType ? 'header-r-hide-equity-tit' : ''}>
                        {
                          benifitMallPrice &&
                            <span>{i18n.t('order.mall')} {i18n.t('checkout.memberPrice')}</span>
                        }
                        {
                          benifitMallRate &&
                            <span>{cardInfo.card?.mallProducts?.length ? i18n.t('mkt.member.someMall') : i18n.t('order.mall')} {format.toDiscount('discountRate', cardInfo.card?.mallDiscountValue)}</span>
                        }
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
            {
              ['half', 'open'].includes(styleType) && cardInfo.card?.isLevel && (cardInfo.card?.nextLevelInfo || cardInfo.card?.level > 1) &&
                <div className='mci-level-info'>
                  <span>{cardInfo.card?.nextLevelInfo ? i18n.t('mkt.member.upgradePoi', { growth: getLevelUpGrowth(cardInfo.card?.nextLevelInfo?.levelGrowth, cardInfo.growth) }) : i18n.t('mkt.member.highestGrade')}</span>
                  <span data-cypid='mmgClickLvMCard' onClick={(e: any) => { e.stopPropagation(); getCardLevel() }}>Lv{cardInfo.card?.nextLevelInfo ? cardInfo.card.level + 1 : cardInfo.card.level}</span>
                  <i data-cypid='mmgClickLvMCardIcon' onClick={(e: any) => { e.stopPropagation(); getCardLevel() }} className='iconfont icon-daohangzhankai'></i>
                </div>
            }
            {
              styleType === 'open' &&
                <div className='mci-equity-info'>
                  {(benifitRecharge) && (
                    <span className='equity-info-price'>
                      {toPrice(cardInfo.balance || 0)}
                      {giveAmount && <span className='equity-info-price-give'>{giveAmount}</span>}
                    </span>
                  )}
                  {benifitIntegral && <span>{i18n.t('mkt.common.integral')} {cardInfo.integral || 0}</span>}
                  {benifitMealPrice && <span>{i18n.t('order.meals')} {i18n.t('checkout.memberPrice')}</span>}
                  {benifitMealRate && <span>{cardInfo.card?.products?.length ? i18n.t('mkt.member.someMeals') : i18n.t('order.meals')} {format.toDiscount('discountRate', cardInfo.card.discountValue)}</span>}
                  {benifitMallPrice && <span>{i18n.t('order.mall')} {i18n.t('checkout.memberPrice')}</span>}
                  {benifitMallRate && !!cardInfo.card.mallDiscountValue &&
                    <span>{cardInfo.card?.mallProducts?.length ? i18n.t('mkt.member.someMall') : i18n.t('order.mall')} {format.toDiscount('discountRate', cardInfo.card.mallDiscountValue)}</span>}
                  {benifitCoupon && <span>{i18n.t('mkt.member.couponSend')}</span>}
                </div>
            }
            {
              isOperate && statusInfo.status !== 2 &&
                <div className='operation-btn'>
                  {
                    (cardInfo.card?.allowAgainLoad || cardInfo.card?.allowCustomizeLoad) && (!cardInfo.expireTime || getExpireDay(cardInfo.expireTime) > 0)
                      ? (
                        <div
                          className='recharge'
                          style={{
                            backgroundColor: cardInfo.card.extra.btnColor || '#B8B8B8 ',
                            color: cardInfo.card.extra.btnFontColor || '#251E1E'
                          }}
                          data-cypid='mmgRechargeMCard'
                          onClick={(e: any) => {
                            e.stopPropagation()
                            if (cardInfo.card.status === 'enable') {
                              goRecharge(`/iCard/cardRecharge/${cardInfo.memberCardId}`)
                            } else {
                              toast({ message: i18n.t('mkt.member.cardDisableTip') })
                            }
                          }}
                        >
                          <span className='btn-text'>{i18n.t('mkt.member.rechargeBalance')}</span>
                        </div>
                      ) : <></>
                  }
                  {
                    cardInfo.card?.type === 'paid' && cardInfo.expireTime &&
                      <div
                        className='recharge'
                        style={{
                          border: `1px solid ${cardInfo.card.extra.btnColor || '#B8B8B8'}`,
                          color: cardInfo.card.extra.btnColor || '#B8B8B8'
                        }}
                        data-cypid='mmgBuyMCard'
                        onClick={(e: any) => {
                          e.stopPropagation()
                          if (cardInfo.card.status === 'enable') {
                            goRecharge(`/iCard/cardOpen/buy/${cardInfo.memberCardId}`)
                          } else {
                            toast({ message: i18n.t('mkt.member.cardDisableTip') })
                          }
                        }}
                      >
                        {getExpireDay(cardInfo.expireTime) <= 3 && <span className='card-expired'>{cardInfo.expireTime && getExpireDay(cardInfo.expireTime) > 0 ? i18n.t('mkt.coupon.expiresInSomeDays', { day: getExpireDay(cardInfo.expireTime) }) : i18n.t('mkt.member.expired')}</span>}
                        <span className='btn-text'>{i18n.t('mkt.member.expireRenew')}</span>
                      </div>
                  }
                </div>
            }
          </div>
          {isOperate && <i className='iconfont icon-erweima'></i>}
          {
            cardInfo.card?.type !== 'paid' && cardInfo.expireTime && getExpireDay(cardInfo.expireTime) <= 0
              ? <div className='status-show'>{i18n.t('mkt.member.expired')}</div>
              : statusInfo.status === 2 ? <div className='status-show'>{i18n.t('mkt.giftCard.frozen')}</div> : <></>
          }
        </div>
      </div>
      {
        detailType === 'open' && <MycardDetailEnter cardInfo={cardInfo}></MycardDetailEnter>
      }
    </>
  )
}

export default observer(CardItem)
